/** Anonymous static data for the work-schedule popup. */
export const legacyWorkScheduleTypes = [
  { id: 'l_scheduleTypeGeneral', label: '일반일정' },
  { id: 'l_scheduleTypeWorkDaily', label: '업무일지' },
  { id: 'l_scheduleTypeShootingWait', label: '촬영대기' },
  { id: 'l_scheduleTypeShoot', label: '촬영스케줄' },
]

export const legacyWorkScheduleStatuses = ['미완료', '완료', '연기', '취소', '변경', '노쇼', '2주', 'OK']
export const legacyWorkScheduleColors = [
  '#131814', '#38b9c2', '#2c9100', '#0033ff', '#5e4200',
  '#f0cc62', '#e63774', '#7b4fc7', '#ff8f3d', '#4285f4',
  '#34a853', '#fbbc04', '#ea4335', '#5f6368', '#8ab4f8',
  '#81c995', '#fde293', '#f28b82', '#d7aefb', '#78d9ec',
]
